const defaultPatterns = {
  g45: true,
  g135: false,
  g90: false,
  g180: false,
};

export function createDiagonalPattern(color = 'blue', patterns = defaultPatterns, boxSize = 16) {
  const { g45, g135, g90, g180 } = patterns;
  const shape = document.createElement('canvas');
  const boxSizeM2 = boxSize - 2;
  shape.width = boxSize;
  shape.height = boxSize;
  const ctx = shape.getContext('2d');
  if (ctx === null) throw Error('[ОШИБКА] При создании canvas паттерна -> не удалось получить 2d контекст');
  ctx.strokeStyle = color;
  ctx.globalCompositeOperation = 'soft-light';
  if (g45) {
    ctx.beginPath();
    ctx.moveTo(boxSizeM2, 0);
    ctx.lineTo(0, boxSizeM2);
    ctx.stroke();
    ctx.beginPath();
    ctx.moveTo(boxSize, boxSizeM2);
    ctx.lineTo(boxSizeM2, boxSize);
    ctx.stroke();
  }
  if (g135) {
    ctx.beginPath();
    ctx.moveTo(2, 0);
    ctx.lineTo(boxSize, boxSizeM2);
    ctx.stroke();
    ctx.beginPath();
    ctx.moveTo(0, boxSizeM2);
    ctx.lineTo(2, boxSize);
    ctx.stroke();
  }

  if (g90) {
    ctx.beginPath();
    ctx.moveTo(boxSizeM2, 0);
    ctx.lineTo(boxSizeM2, boxSize);
    ctx.stroke();
  }

  if (g180) {
    ctx.beginPath();
    ctx.moveTo(0, boxSizeM2);
    ctx.lineTo(boxSize, boxSizeM2);
    ctx.stroke();
  }

  const pattern = ctx.createPattern(shape, 'repeat');
  if (pattern === null) throw Error('[ОШИБКА] При создании canvas паттерна -> не удалось создать паттерн');
  return pattern;
}
